import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBattleDotNetComponent } from './simple-icons-battle-dot-net.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBattleDotNetComponent ],
    exports:      [ SimpleIconsBattleDotNetComponent ],
    bootstrap:    []
})
export class SimpleIconsBattleDotNetModule {}
